import { Button } from "@/components/ui/button";

export function Pager({ page, total, pageSize, onPage }) {
  if (total <= pageSize) return null;
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  const last = (page + 1) * pageSize >= total;
  return (
    <div className="flex items-center justify-between mt-3" data-testid="pager">
      <p className="text-xs text-muted-foreground">Showing {start}–{end} of {total}</p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" data-testid="pager-prev" disabled={page === 0} onClick={() => onPage(Math.max(0, page - 1))} className="rounded-lg h-8 border-black/10">Prev</Button>
        <Button size="sm" variant="outline" data-testid="pager-next" disabled={last} onClick={() => onPage(page + 1)} className="rounded-lg h-8 border-black/10">Next</Button>
      </div>
    </div>
  );
}
